import React from "react";
import FaceBookIcon from "./../images/facebook.svg";
import XIcon from "./../images/x.svg";
import WhatsappIcon from './../images/whatsapp.svg';

const SocialShare = ({ slug, title }) => {
  const url = `https://www.gardnhub.com/blog/${slug}`;
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  return (
    <div className="mt-normal text-[16px]">
      Liked this article? Share it with your friends!
      <div className="flex gap-4 mt-4">
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={FaceBookIcon} alt="Facebook" height={32} width={32} />
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={XIcon} alt="Twitter" height={32} width={32} />
      </a>
      <a
        href={`https://wa.me/?text=${encodedTitle} ${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={WhatsappIcon} alt="WhatsApp" height={32} width={32} />
      </a>
      </div>
    </div>
  );
};

export default SocialShare;
